import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articleSlugs, articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 pt-16 md:pt-20 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl text-foreground-900">
                Superbuy <span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              The ultimate resource hub for organized product discovery. Helping shoppers find better products faster.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-global-line"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-3-line"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-foreground-800 mb-4 text-sm">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Home</Link>
              <Link to="/blog/superbuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Complete Guide</Link>
              <Link to="/blog/best-superbuy-spreadsheet-2026" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Best of 2026</Link>
              <Link to="/blog/how-to-use-superbuy-spreadsheet" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Beginner Tutorial</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Superbuy Sheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">Buy It Now</a>
            </div>
          </div>

          {/* Top Categories */}
          <div>
            <h4 className="font-semibold text-foreground-800 mb-4 text-sm">Top Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
              <a
                href={categories[0].url}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium cursor-pointer"
              >
                View All Categories <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          </div>

          {/* Guides */}
          <div>
            <h4 className="font-semibold text-foreground-800 mb-4 text-sm">SEO Guides</h4>
            <div className="flex flex-col gap-2.5">
              {articleSlugs.slice(0, 6).map((slug) => (
                <Link
                  key={slug}
                  to={`/blog/${slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors truncate cursor-pointer"
                >
                  {articles[slug].h1}
                </Link>
              ))}
              {articleSlugs.length > 6 && (
                <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium cursor-pointer">
                  View All Guides <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. This is an informational resource. 
            All external links lead to <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-500 hover:text-primary-600 cursor-pointer">kaspreadsheet.com</a>.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">Privacy</Link>
            <Link to="/" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}